import React, { useEffect, useState } from "react";
import { Breadcrumbs } from "../Components/Breadcrumbs";
import { fetchAllManagement } from "../Services/ManagementService";
import Image from '../Components/Image'
import { Helmet } from "react-helmet-async";

const ManagementScreen = () => {
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedWing, setSelectedWing] = useState("All");
    const [managementData, setManagementData] = useState([]);

    useEffect(() => {
        getManagementData();
    }, [managementData])


    const getManagementData = async () => {
        await fetchAllManagement(setManagementData);
    }


    const filteredManagement = managementData.filter((management) => {
        const matchesSearch = management.name.toLowerCase().includes(searchQuery.toLowerCase());
        const matchesWing = selectedWing === "All" || management.wing === selectedWing;
        return matchesSearch && matchesWing;
    });
    return <>
        <Helmet>
            <title>Management</title>
            <meta name="description" content=" Oasis Educational Institute" />
        </Helmet>

        <Breadcrumbs page="Management" label="Home" path="/" />

        <div className="min-h-screen bg-gray-50 p-8">
       
            <div className="text-center mb-8">
                <h1 className="text-4xl font-bold text-navy-yellow">Our Management Team</h1>
                <p className="text-gray-600 mt-2">OASIS Educational Institute</p>
            </div>

        
            <div className="flex flex-col md:flex-row justify-between items-center mb-8">
                <input
                    type="text"
                    placeholder="Search by name..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className="w-full md:w-1/3 p-2 border border-gray-300 rounded-lg mb-4 md:mb-0"
                />
                <select
                    value={selectedWing}
                    onChange={(e) => setSelectedWing(e.target.value)}
                    className="w-full md:w-1/4 p-2 border border-gray-300 rounded-lg"
                >
                    <option value="All">All Wings</option>
                    <option value="Gogji Bagh-Srinagar">Gogji Bagh-Srinagar</option>
                    <option value="Gulshan Nagar-Srinagar">Gulshan Nagar-Srinagar</option>
                </select>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 m-4">
                {filteredManagement.map((management, index) => (
                    <div key={index} className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow">
                        <div className="text-center">
                            <div >
                                <Image id={management.file_id} className="w-40 h-40 bg-gray-200 rounded-full mx-auto mb-4" />
                            </div>
                            <h2 className="text-xl font-semibold text-gray-800">{management.name}</h2>
                            <p className="text-yellow-600 mt-2">{management.position}</p>
                            <p className="text-sm text-gray-500 mt-1">{management.institute}</p>
                            <p className="text-xs text-gray-400 mt-1">{management.wing}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>


    </>;
};

export default ManagementScreen;